/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AnnualInputs */

const en_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual`)
};

const es_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const fr_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const de_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const ja_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年額`)
};

const zh_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按年`)
};

const ar_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوياً`)
};

const id_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahunan`)
};

const it_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const ru_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодно`)
};

const pt_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const ko_annual = /** @type {(inputs: AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간`)
};

/**
* | output |
* | --- |
* | "Annual" |
*
* @param {AnnualInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const annual = /** @type {((inputs?: AnnualInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AnnualInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_annual(inputs)
	if (locale === "es") return es_annual(inputs)
	if (locale === "fr") return fr_annual(inputs)
	if (locale === "de") return de_annual(inputs)
	if (locale === "ja") return ja_annual(inputs)
	if (locale === "zh") return zh_annual(inputs)
	if (locale === "ar") return ar_annual(inputs)
	if (locale === "id") return id_annual(inputs)
	if (locale === "it") return it_annual(inputs)
	if (locale === "ru") return ru_annual(inputs)
	if (locale === "pt") return pt_annual(inputs)
	return ko_annual(inputs)
});